<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.skuName')" prop="skuName">
            <BjInput v-model="queryParams.skuName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.skuName')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.skuCode')" prop="skuCode">
            <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.skuCode')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')">
            <BjSelectLov v-model="tempStatus" :option-list="GOODS_AUDIT_STATUS_STRING_LIST" :placeholder="$t('table.statusText')" multiple />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.Dimensional')">
            <BjSelectLov v-model="queryParams.dimensionsChecked" :option-list="STATUS_YES_TRUE" :placeholder="$t('goodsPage.Dimensional')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BjDialogListConfig.Producttype')">
            <BjSelectLov v-model="queryParams.itemType" :option-list="ITEM_TYPE_CHOOSE" :placeholder="$t('BjDialogListConfig.Producttype')" />
          </el-form-item>
        </el-col>

      </template>
      <template v-slot:tableOperation> </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'materialMainImages'">
                <BjViewUrl height="80px" :url="(scope.row[col.prop] || [])[0]" preview />
              </template>
              <el-tag v-else-if="col.prop === 'status'">
                {{ $t(GOODS_AUDIT_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </el-tag>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" @click="onLook(props.row)">{{ $t('viewText') }}</el-button>
              <el-button v-if="props.row.status == 2 || props.row.status == 4" type="text" @click="onAudit(props.row)">{{ $t('table.auditText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>

<script>
import { goodsApi } from '@/api';
import pageMiXin from '@/utils/page-mixin.js';
import { GOODS_TYPE_LIST, GOODS_AUDIT_STATUS_LIST, GOODS_COMBO_TYPES, STATUS_YES_TRUE, ITEM_TYPE_CHOOSE } from '@/utils/constants';
const DEFAULT_STATUS = [...GOODS_AUDIT_STATUS_LIST[0].value];
const GOODS_AUDIT_STATUS_STRING_LIST = [
  ...GOODS_AUDIT_STATUS_LIST.map(e => {
    return {
      ...e,
      value: e.value + '',
    };
  }),
];
const DEFAULT_STATUS_STRING = [GOODS_AUDIT_STATUS_STRING_LIST[0].value];
export default {
  name: 'BusinessGoodsAuditSkuPageOrdinaryPackage',
  mixins: [pageMiXin],
  props: {
    setFlag: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      colSpan: 4,
      selection: false,
      GOODS_TYPE_LIST,
      STATUS_YES_TRUE,
      ITEM_TYPE_CHOOSE,
      GOODS_AUDIT_STATUS_LIST,
      GOODS_AUDIT_STATUS_STRING_LIST,
      queryApi: goodsApi.getSkuAuditList, // settingApi.getStockProcess,
      // 查询参数
      tempStatus: DEFAULT_STATUS_STRING,
      queryParams: {
        skuCode: null,
        spuName: null,
        dimensionsChecked: null,
        itemType: null,
        status: DEFAULT_STATUS,
        setFlag: this.setFlag,
      },
      srcList: [],
      labelsVersion: 11,
      labelList: [
        { label: 'goodsPage.skuCode', prop: 'skuCode', isCheck: true, disabled: false, width: 180 },
        { label: 'goodsPage.skuName', prop: 'skuName', isCheck: true, disabled: false, width: 180 },
        { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false, width: 180 },
        { label: 'table.remarkText', prop: 'goodsRemark', isCheck: true, disabled: false },
        { label: 'goodsAudit.page.Approvaltime', prop: 'auditCommitDate', isCheck: true, disabled: false, width: 180 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
      ],
    };
  },
  computed: {},
  watch: {
    tempStatus(v, o) {
      if (Array.isArray(v) && v.length) {
        const TEMP = [];
        v.forEach(e => {
          e = e.split(',');
          TEMP.push(...e);
        });
        this.queryParams.status = TEMP.map(e => Number(e));
      } else {
        this.queryParams.status = [];
        GOODS_AUDIT_STATUS_LIST.map(e => e.value).forEach(e => {
          this.queryParams.status.push(...e);
        });
      }
    },
  },
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.tempStatus = DEFAULT_STATUS_STRING;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 查 看 */
    onLook(row) {
      const { status, id } = row;
      const NAME =
        this.setFlag == GOODS_COMBO_TYPES.PACKAGE
          ? 'BusinessGoodsAuditSkuPackageView'
          : 'BusinessGoodsAuditSkuOrdinaryView';
      this.$router.push({
        name: NAME,
        query: {
          id,
          status,
        },
      });
    },
    /** 审 核 */
    onAudit(row) {
      const { status, id } = row;
      const NAME =
        this.setFlag == GOODS_COMBO_TYPES.PACKAGE
          ? 'BusinessGoodsAuditSkuPackageAudit'
          : 'BusinessGoodsAuditSkuOrdinaryAudit';
      this.$router.push({
        name: NAME,
        query: {
          id,
          status,
        },
      });
    },
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
